import api, { request } from '../../../api';
import { groupBy } from '../../../contrib/utils';
import { IErrorsStore } from '../../errors/store';
import { IActionGroup, IStore } from '../../index';
import { IRoundResultsStore } from './store';

export interface IRoundResultsActions {
  get: (
    roundId: number,
    eventId: number,
    force?: boolean
  ) => { roundResults?: IRoundResultsStore; errors?: IErrorsStore };
}

const actions: IActionGroup = {
  get: async (state: IStore, roundId: number, eventId: number, force?: boolean) => {
    if (state.roundResults[roundId] && !force) {
      return {
        roundResults: state.roundResults
      };
    }

    const apiEndpoint =
      roundId > 0
        ? api.results('player', 'rounds', { round_id: roundId })
        : api.results('player', 'events', { event_id: eventId });

    const response = await request.get(apiEndpoint);

    if (response.error) {
      return {
        errors: { roundResults: { msg: 'Error retrieving the Round Format Awards List.' } }
      };
    }

    return {
      roundResults: {
        ...state.roundResults,
        [roundId]: {
          ...state.roundResults[roundId],
          ...groupBy(response, 'flightId')
        }
      }
    };
  }
};

export default actions;
